import { render } from "./ChildRalliesPage.vue?vue&type=template&id=350755a6"
import script from "./ChildRalliesPage.vue?vue&type=script&lang=js"
export * from "./ChildRalliesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__